import actionTypes from './types';

export const fetchLoadTypesStart = () => ({
  type: actionTypes.FETCH_LOAD_TYPES_START,
});

export const fetchLoadTypesSuccess = (payload: any) => ({
  type: actionTypes.FETCH_LOAD_TYPES_SUCCESS,
  payload,
});

export const fetchConsignmentDetailsStart = (payload: number) => ({
  type: actionTypes.FETCH_CONSIGNMENT_DETAILS_START,
  payload,
});

export const fetchConsignmentDetailsSuccess = (payload: any) => ({
  type: actionTypes.FETCH_CONSIGNMENT_DETAILS_SUCCESS,
  payload,
});

export const fetchLanesStart = (payload: number) => ({
  type: actionTypes.FETCH_LANES_START,
  payload,
});

export const fetchLanesSuccess = (payload: any) => ({
  type: actionTypes.FETCH_LANES_SUCCESS,
  payload,
});

export const updateConsignment = (payload: any) => ({
  type: actionTypes.UPDATE_CONSIGNMENT,
  payload,
});

export const updatePolyline = (payload: any) => ({
  type: actionTypes.UPDATE_POLYLINE,
  payload,
});
